/**
 * CampGetReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * CampGetReq
 */
export interface CampGetReq {
  /** 大本营ID，逗号分隔 */
  id: string
}

/**
 * CampGetReq Schema
 */
export const CampGetReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '大本营ID，逗号分隔',
      format: 'string',
      type: 'string',
      label: '大本营ID',
    },
  },
  required: ['id'],
  type: 'object',
}
